import React from "react";

function Header() {
  return (
    <div className="py-3">
      <div className="row pt-3">
        <div className="col-12">
          <h1 className="font-weight-bolder">입주민 관리</h1>
        </div>
      </div>
    </div>
  );
}

export default Header;
